<template>
  <div class="citizen-notification-wrapper">
    <div class="print-actions mb-3">
      <b-button
        variant="primary"
        :disabled="!requestDetails || printing"
        @click="printDocument"
      >
        <b-spinner
          v-if="printing"
          small
          class="ml-1"
        />
        <feather-icon
          v-else
          icon="PrinterIcon"
          size="16"
          class="ml-1"
        />
        طباعة / PDF
      </b-button>
      <b-button
        variant="outline-secondary"
        class="mr-2"
        @click="resetFromRequest"
      >
        إعادة تعبئة البيانات
      </b-button>
    </div>

    <div
      id="citizen-notification"
      class="citizen-notification-document"
    >
      <!-- Header -->
      <div class="doc-header">
        
        <div class="doc-header-text">
          <p class="header-line">
            الهيئه العامه للاصلاح الزراعي
          </p>
          <p class="header-line">
            مديرية الاصلاح الزراعي باسيوط
          </p>
          <p class="header-line">
            ادارة املاك الدوله الخاصه
          </p>
        </div>
        <img
          :src="logoSrc"
          alt="شعار الهيئة"
          class="doc-logo"
        >
      </div>

      <!-- Recipient & notification number -->
      <div class="recipient-row">
        <p class="recipient-text">
          السيد الاستاذ / {{ form.recipient }}
        </p>
        
            
            
        <p class=" dynamic-value">
          ( اخطار رقم <span>{{ toArabicDigits(form.serial) }}</span> )
            <span class="dynamic-value">{{ toArabicDigits(form.year) }}م</span>
        </p>
        <p class="greeting">
            تحيه طيبه وبعد ,,,,,
        </p>
      </div>


      <!-- Main body -->
      <p class="body-paragraph">
        بناء على كتاب مديرية الاصلاح الزراعي باسيوط الوارد الى الاداره برقم
        <span class="dynamic-value">{{ toArabicDigits(form.letterNumber) }}</span>
        في
        <span class="dynamic-value">{{ toArabicDigits(form.letterDate) }}</span>
        وايماء الى الكشوف المسلمه من الوحده المحليه لمركز ومدينة 
        <span class="dynamic-value">{{ form.governorate }}</span>
         ناحية
        <span class="dynamic-value">{{ form.center }}</span>
        المواطن /
        <span class="dynamic-value">{{ form.citizenName }}</span>
        <span v-if="customerNames">عن</span>
        <span v-if="customerNames" class="dynamic-value">{{ customerNames }}</span>
        ويحمل كود منظومه طرفكم رقم
        <span class="dynamic-value">{{ toArabicDigits(form.systemCode) }}</span>
        بمساحة (
        <span class="dynamic-value">{{ toArabicDigits(form.areaS) }}</span>
        س
        <span class="dynamic-value">{{ toArabicDigits(form.areaT) }}</span>
        ط
        <span class="dynamic-value">{{ toArabicDigits(form.areaF) }}</span>
        ف )
        (
        <span class="dynamic-value">{{ toArabicDigits(formattedAreaMeters) }}</span>
        متر )
        بناء على طلب التقنين طبقا للقانون {{ toArabicDigits(144) }}لسنة {{ toArabicDigits(2017) }} ولائحته التنفيذيه نحيط علم سيادتكم بان المواطن المذكور بعاليه يتم تحصيل مبلغ
        <span class="dynamic-value">{{ formattedAmount }}</span>
        جنيها
        ( فقط
        <span class="dynamic-value">{{ form.amountInWords }}</span>
        )
        في حق الشعب وفقا للتعليمات الصادره لكم في هذا الشأن دون ادنى مسئوليه على ادارة املاك الدوله الخاصه و بناء على تسعير القيمه الايجاريه الوارده من اللجان المشكله بكل مركز في شهر مايو {{ toArabicDigits(2025) }} بناء على قرار المحافظه رقم {{ toArabicDigits(1887) }} وتعليمات لجنة استرداد الاراضي التسعير بالمثل مع احضار صوره طبق الاصل من اشعار الدفع حتى نتمكن من تحرير العقد .
      </p>
        <p class="closing">
            وتفضلوا بقبول وافر الاحترام ,,,,
        </p>
        
      <p class="issue-date">
        تحريرا في
        <span class="dynamic-value">{{ toArabicDigits(form.issueDay) }}</span>
        /
        <span class="dynamic-value">{{ toArabicDigits(form.issueMonth) }}</span>
        /
        <span class="dynamic-value">{{ toArabicDigits(form.issueYear) }}</span>
        م
      </p>

      <!-- Signatures -->
      <div class="signatures">
        <div class="signatures-row">
          <div class="signature-label">كاتب الحسابات</div>
          <div> 
            <span class="signature-label">رئيس حسابات </span>
            <br/>
            <span class="signature-name">{{ form.signatureHeadOfAccounts }}</span>
          </div>
          <div> 
            <span class="signature-label"> رئيس الاملاك </span>
            <br/>
            <span class="signature-name">{{ form.signatureHeadOfProperty }}</span>
          </div>
          <div> 
            <span class="signature-label"> مدير إدارة أملاك الدولة </span>
            <br/>
            <span class="signature-name">{{ form.signatureDirector }}</span>
          </div>
          
            
        </div>
        
      </div>
    </div>

    <!-- Editable fields (screen only) -->
    <b-card
      v-if="requestDetails"
      class="edit-panel mt-3"
      title="تعديل بيانات الإخطار"
    >
      <b-row>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="المستلم">
            <b-form-input v-model="form.recipient" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="رقم الإخطار (مسلسل)">
            <b-form-input v-model="form.serial" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="السنة">
            <b-form-input
              v-model="form.year"
              type="text"
              placeholder="مثال: 2026"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="رقم الكتاب">
            <b-form-input v-model="form.letterNumber" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="تاريخ الكتاب">
            <b-form-input v-model="form.letterDate" />
          </b-form-group>
        </b-col>
        
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="المحافظة">
            <b-form-input v-model="form.governorate" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="الناحية / المركز">
            <b-form-input v-model="form.center" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="اسم المواطن">
            <b-form-input v-model="form.citizenName" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="كود المنظومة">
            <b-form-input v-model="form.systemCode" />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="س">
            <b-form-input
              v-model="form.areaS"
              @input="updateAmountInWords"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="ط">
            <b-form-input
              v-model="form.areaT"
              @input="updateAmountInWords"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="ف">
            <b-form-input
              v-model="form.areaF"
              @input="updateAmountInWords"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="المساحة (متر)">
            <b-form-input
              v-model="form.areaMeters"
              type="number"
              step="0.01"
              @input="updateAmountInWords"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          sm="6"
          class="mb-2"
        >
          <b-form-group label=" المبلغ(للفئة)">
            <b-form-input
              v-model="form.price"
              type="number"
              step="0.01"
              @input="updateAmountInWords"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="12"
          class="mb-2"
        >
          <b-form-group label="المبلغ تفقيطاً">
            <b-form-input v-model="form.amountInWords" />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="يوم التحرير">
            <b-form-input v-model="form.issueDay" />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="شهر التحرير">
            <b-form-input v-model="form.issueMonth" />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="4"
          class="mb-2"
        >
          <b-form-group label="سنة التحرير">
            <b-form-input v-model="form.issueYear" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="رئيس حسابات">
            <b-form-input v-model="form.signatureHeadOfAccounts" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="رئيس الاملاك">
            <b-form-input v-model="form.signatureHeadOfProperty" />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          class="mb-2"
        >
          <b-form-group label="مدير إدارة أملاك الدولة">
            <b-form-input v-model="form.signatureDirector" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BButton, BCard, BRow, BCol, BFormGroup, BFormInput, BSpinner,
} from 'bootstrap-vue'
import numberToArabicWords from '@/utils/numberToArabicWords'
import externalRequestsApi from '@/api/external-requests/externalRequests'

const defaultForm = () => ({
  recipient: 'مسئول منظومة التقنين بديوان عام محافظة اسيوط',
  serial: '',
  year: new Date().getFullYear().toString(),
  letterNumber: '',
  letterDate: '',
  governorate: '',
  center: '',
  localUnit: '',
  citizenName: '',
  systemCode: '',
  areaS: '0',
  areaT: '0',
  areaF: '0',
  areaMeters: '',
  price: '',
  amountInWords: '',
  issueDay: '',
  issueMonth: '',
  issueYear: new Date().getFullYear().toString(),
  signatureHeadOfAccounts: 'أ / عادل عدلى',
  signatureHeadOfProperty: 'ا/نشوى محمد',
  signatureDirector: 'م/ احمد سيد عبدالرحيم',
})

export default {
  name: 'CitizenNotification',
  components: {
    BButton, BCard, BRow, BCol, BFormGroup, BFormInput, BSpinner,
  },
  props: {
    requestDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      logoSrc: require('@/assets/images/reports/agricultural-reform-logo.jpeg'),
      form: defaultForm(),
      printing: false,
    }
  },
  computed: {
    calculatedAmount() {
      const areaS = Number(this.form.areaS) || 0
      const areaT = Number(this.form.areaT) || 0
      const areaF = Number(this.form.areaF) || 0
      const areaMeters = Number(this.form.areaMeters) || 0
      const price = Number(this.form.price) || 0

      const feddansPart = Math.round(((areaS / 24 + areaT) / 24 + areaF) * price * 10) / 10
      const metersPart = Math.round(areaMeters * price * 100) / 100

      return feddansPart + metersPart
    },
    customerNames() {
      const customers = this.requestDetails?.customers 
       let value = Array.isArray(customers) ? customers.map(customer => customer.name).join(', ') : ''
      return value || false;
    },
    formattedAmount() {
      const amount = this.calculatedAmount
      if (Number.isNaN(amount)) return ''
      const formatted = amount.toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      return this.toArabicDigits(formatted)
    },
    formattedAreaMeters() {
      const val = this.form.areaMeters
      if (val === '' || val == null) return ''
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toLocaleString('ar-EG', { maximumFractionDigits: 2 })
    },
  },
  watch: {
    requestDetails: {
      immediate: true,
      handler(val) {
        if (val) this.populateFromRequest(val)
      },
    },
  },
  methods: {

    toArabicDigits(value) {
      if (value === null || value === undefined || value === '') return ''
      const digits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
      return String(value)
        .split('')
        .map(ch => (/\d/.test(ch) ? digits[parseInt(ch, 10)] : ch))
        .join('')
    },
    populateFromRequest(r) {
      const today = new Date()
      const financial = Array.isArray(r.external_financials) && r.external_financials.length
        ? r.external_financials[0]
        : null

      this.form = {
        ...defaultForm(),
        serial: r.request_number || r.id || '',
        citizenName: r.name || '',
        systemCode: r.request_number || r.order_code || '',
        governorate: (r.governorate && (r.governorate.name_ar || r.governorate.name)) || '',
        center: (r.center && (r.center.name_ar || r.center.name)) || '',
        localUnit: r.place || r.handling_authority || '',
        areaMeters: this.extractMeters(r),
        price: '10',
        letterNumber: '6239',
        letterDate: '28/8/2025',
        issueDay: String(today.getDate()),
        issueMonth: String(today.getMonth() + 1),
        issueYear: String(today.getFullYear()),
      }
      this.parseAreaUnits(r)
      this.updateAmountInWords()
      this.fetchSerialLetter(r.id)
    },
    async fetchSerialLetter(id) {
      if (!id) return
      try {
        const response = await externalRequestsApi.SerialLetter(id)
        const serial = response?.data?.serial ?? response?.serial
        if (serial != null && serial !== '') {
          this.form.serial = String(serial)
        }
      } catch (error) {
        console.error('Failed to fetch serial letter number:', error)
      }
    },
    extractMeters(r) {
      if (!r.area) return ''
      const unit = (r.unit || '').toString().trim()
      if (unit.includes('متر') || unit.toLowerCase() === 'm') {
        return r.area
      }
      return r.area_meters || r.area_in_meters || ''
    },
    parseAreaUnits(r) {
      let unit = (r.unit || '').toString().trim()
      if(unit = 'فدان') {
        this.form.areaF = r.area || ''
        this.form.areaT = '0'
        this.form.areaS = '0'
        this.form.areaMeters = r.area * 4200.83
      }
      if(unit == 'قيراط') {
        this.form.areaF = '0'
        this.form.areaT = r.area || ''
        this.form.areaS = '0'
        this.form.areaMeters = r.area * 175
      }
      if(unit == 'سهم') {
        this.form.areaF = '0'
        this.form.areaT = '0'
        this.form.areaS = r.area || ''
        this.form.areaMeters = r.area * 7.291666666666667
      }
      
    },
    updateAmountInWords() {
      const amount = this.calculatedAmount
      if (amount || amount === 0) {
        this.form.amountInWords = numberToArabicWords(amount)
      }
    },
    resetFromRequest() {
      if (this.requestDetails) this.populateFromRequest(this.requestDetails)
    },
    getDocumentPrintStyles() {
      return `
        * { box-sizing: border-box; }
        html, body {
          margin: 0;
          padding: 0;
          background: #fff;
          color: #000;
          direction: rtl;
          font-family: 'Noto Naskh Arabic', 'Traditional Arabic', 'Arial', serif;
        }
        .citizen-notification-document {
          background: #fff;
          width: 210mm;
          max-width: 210mm;
          margin: 0 auto;
          padding: 6mm;
          color: #000;
          font-size: 16pt;
          line-height: 1.8;
          box-shadow: none;
          page-break-inside: avoid;
          page-break-after: avoid;
        }
        .doc-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          margin-bottom: 1rem;
        }
        .doc-logo {
          width: 80px;
          height: auto;
          flex-shrink: 0;
        }
        .doc-header-text {
          flex: 0 1 auto;
          text-align: right;
          font-weight: 400;
          font-size: 14pt;
          line-height: 1.25;
        }
        .header-line {
          margin: 0;
          line-height: 1.25;
        }
        .recipient-row {
          margin-bottom: 1rem;
          text-align: center;
        }
        .recipient-text {
          margin: 0 0 0.5rem;
          font-weight: bold;
        }
        .greeting {
          margin: 1rem 0;
        }
        .body-paragraph {
          text-align: justify;
          text-justify: inter-word;
          margin: 1rem 0;
          line-height: 2;
        }
        .dynamic-value {
          display: inline;
          padding: 0 4px;
          font-weight: bold;
          min-width: 2em;
        }
        .closing {
          margin: 1.5rem 0 1rem;
          text-align: center;
        }
        .issue-date {
          margin: 1rem 0 2rem;
        }
        .signatures {
          margin-top: 2.5rem;
          font-size: 13pt;
          page-break-inside: avoid;
        }
        .signatures-row {
          display: flex;
          justify-content: space-between;
          text-align: center;
          gap: 0.5rem;
        }
        .signatures-row > div {
          flex: 1;
        }
        .signature-label {
          font-weight: bold;
          margin-bottom: 0.3rem;
          font-size: 1.2rem;
          line-height: 1.2;
        }
        .signature-name {
          font-weight: bold;
          margin-bottom: 0.3rem;
          font-size: 1rem;
          line-height: 1.2;
        }
        img {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        @page {
          size: A4 portrait;
          margin: 0;
        }
      `
    },
    async waitForImages(root) {
      const images = Array.from(root.querySelectorAll('img'))
      await Promise.all(images.map(img => new Promise((resolve) => {
        if (img.complete) resolve()
        else {
          img.onload = resolve
          img.onerror = resolve
        }
      })))
    },
    async printDocument() {
      await externalRequestsApi.PrintLetter(this.requestDetails.id)
      const element = document.getElementById('citizen-notification')
      if (!element || this.printing) return

      this.printing = true
      let iframe = null

      try {
        let html = element.outerHTML
        const logo = element.querySelector('img')
        if (logo?.src) {
          html = html.replace(
            /<img([^>]*?)src="[^"]*"/,
            `<img$1src="${logo.src}"`,
          )
        }

        iframe = document.createElement('iframe')
        iframe.style.cssText = 'position:fixed;left:-10000px;top:0;width:210mm;height:297mm;border:0;'
        document.body.appendChild(iframe)

        const win = iframe.contentWindow
        const doc = win.document

        doc.open()
        doc.write(`<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
  <meta charset="utf-8">
  <title>إخطار المواطن</title>
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600;700&display=swap">
  <style>${this.getDocumentPrintStyles()}</style>
</head>
<body>${html}</body>
</html>`)
        doc.close()

        await this.waitForImages(doc.body)
        if (doc.fonts?.ready) await doc.fonts.ready

        // Scale down only if content exceeds one A4 page — keeps preview proportions
        const docRoot = doc.querySelector('.citizen-notification-document')
        const pageHeightPx = (297 / 25.4) * 96
        if (docRoot && docRoot.scrollHeight > pageHeightPx) {
          const scale = pageHeightPx / docRoot.scrollHeight
          docRoot.style.transform = `scale(${scale})`
          docRoot.style.transformOrigin = 'top center'
          doc.body.style.height = `${pageHeightPx}px`
          doc.body.style.overflow = 'hidden'
        }

        const cleanup = () => {
          if (iframe?.parentNode) iframe.parentNode.removeChild(iframe)
        }

        win.focus()
        win.print()
        if ('onafterprint' in win) {
          win.onafterprint = cleanup
        }
        setTimeout(cleanup, 3000)
      } catch (error) {
        console.error(error)
        this.$toast?.error?.('تعذر الطباعة')
        if (iframe?.parentNode) iframe.parentNode.removeChild(iframe)
      } finally {
        this.printing = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.citizen-notification-wrapper {
  font-family: 'Noto Naskh Arabic', 'Traditional Arabic', 'Arial', serif;
}

.print-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.citizen-notification-document {
  background: #fff;
  max-width: 210mm;
  margin: 0 auto;
  padding: 6mm 6mm 6mm;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  color: #000;
  font-size: 16pt;
  line-height: 1.8;
}

.doc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 1rem;
  position: relative;
}

.doc-logo {
  width: 80px;
  height: auto;
  flex-shrink: 0;
}

.doc-header-text {
  flex: 0 1 auto;
  text-align: right;
  font-weight: 400;
  font-size: 14pt;
  line-height: 1.25;

  .header-line {
    margin: 0;
    line-height: 1.25;
  }
}

.recipient-row {
  margin-bottom: 1rem;
  text-align: center;

  .recipient-text {
    margin: 0 0 0.5rem;
    font-weight: bold;
  }

  .notification-meta {
    margin: 0;
    text-align: left;
  }
}

.greeting {
  margin: 1rem 0;
}

.body-paragraph {
  text-align: justify;
  text-justify: inter-word;
  margin: 1rem 0;
  line-height: 2;
}

.dynamic-value {
  display: inline;
//   border-bottom: 1px dotted #333;
  padding: 0 4px;
  font-weight: bold;
  min-width: 2em;
}

.closing {
  margin: 1.5rem 0 1rem;
  text-align: center;
}

.issue-date {
  margin: 1rem 0 2rem;
}

.signatures {
  margin-top: 2.5rem;
  font-size: 13pt;

  .signatures-row {
    display: flex;
    justify-content: space-between;
    text-align: center;
    gap: 0.5rem;

    > div {
      flex: 1;
    }
  }

  .signature-label {
    font-weight: bold;
    margin-bottom: 0.3rem;
    font-size: 1.2rem;
    line-height: 1.2;
  }
  .signature-name {
    font-weight: bold;
    margin-bottom: 0.3rem;
    font-size: 1rem;
    line-height: 1.2;
  }
}

.edit-panel {
  max-width: 210mm;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style lang="scss">
@media print {
  body * {
    visibility: hidden !important;
  }

  nav,
  header,
  footer,
  .main-menu,
  .header-navbar,
  .header-navbar-shadow,
  .customizer-toggle,
  .sidebar,
  .navbar,
  .vue-toastification,
  .toast-container,
  .breadcrumb,
  .nav,
  .nav-tabs,
  .nav-link,
  .b-tabs-nav,
  .b-tabs-nav-wrapper,
  .nav-item,
  ul[role="tablist"],
  [role="navigation"],
  [role="tablist"],
  .content-header,
  .content-header-left,
  .breadcrumb-wrapper,
  .breadcrumbs-top {
    display: none !important;
    visibility: hidden !important;
  }

  .tab-pane:has(#citizen-notification),
  .citizen-notification-wrapper {
    display: block !important;
    visibility: visible !important;
  }

  .citizen-notification-wrapper {
    padding: 0 !important;
    margin: 0 !important;
    background: #fff !important;
    display: block !important;
    visibility: visible !important;
    width: 100% !important;
    min-height: 0 !important;
    height: auto !important;
    position: static !important;
    overflow: visible !important;
  }

  .citizen-notification-wrapper > *:not(#citizen-notification) {
    display: none !important;
    visibility: hidden !important;
  }

  #citizen-notification,
  #citizen-notification * {
    visibility: visible !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #citizen-notification {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    box-shadow: none !important;
    max-width: 100% !important;
    width: 100% !important;
    min-height: auto !important;
    height: auto !important;
    padding: 10mm 12mm !important;
    margin: 0 !important;
    page-break-inside: avoid;
    display: block !important;
    background: #fff !important;
  }

  #citizen-notification .dynamic-value {
    border-bottom: none !important;
  }

  #citizen-notification img {
    display: inline-block !important;
    visibility: visible !important;
  }

  body,
  html {
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    overflow: visible !important;
  }

  .content.app-content {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
  }

  @page {
    size: A4 portrait;
    margin: 8mm;
  }
}
</style>
